import { BaseError } from "./base-error.js";
export class ConflictError extends BaseError {
    static code = 'ConflictError';
    static statusCode = 409;
    data;
    constructor(message = 'Conflict', data, options = {}) {
        super(message, options);
        this.data = data;
    }
}
